import React from "react";
import { LANDING_PAGE_HERO_CARDS } from "../../constants/text_constants";
import { useSelector } from "react-redux";
import ScrollCarousel from "scroll-carousel-react";
import { useMediaQuery } from "react-responsive";

const Herocards = () => {
  const isSideBarOpen = useSelector((store) => store.sidebar.isSideBarOpen);
  const isMobile = useMediaQuery({ maxWidth: 767 }); // Tailwind md breakpoint is 768px

  return (
    <div className={" md:border-t-0 md:border-b-0 border-t-[2px] border-b-[2px] border-gray-200  mt-[1rem] lg:mb-[4rem] " + (isSideBarOpen ? "" : "lg:grid md:grid-cols-2 grid-cols-1 lg:gap-3 ") + "grid md:grid-cols-2 grid-cols-1 gap-5"}>
      
      {
        isMobile ? <ScrollCarousel autoplay autoplaySpeed={8} speed={7}>
        {LANDING_PAGE_HERO_CARDS.map((d, i) => (
          <div
            className="text-center w-[200px]  flex flex-col items-center bg-[#F8FCFD] lg:p-10 p-5 rounded-lg hover:bg-gradient-to-r from-cyan-100 to-purple-100 cursor-pointer"
            key={i}
          >
            <img
              alt={"hero-card" + d?.id}
              src={d?.img}
              className="lg:w-13 bg-white p-2 rounded-full w-[50px]"
              loading="lazy"
            />
            <div
              style={{
                fontFamily: "DM Sans",
                textAlign: "center",
                fontStyle: "normal",
                lineHeight: "normal",
              }}
            >
              <div className="text-[#130C40] lg:text-lg text-[0.8rem]">
                {d?.title}
              </div>
              <div className="text-[#3F3D4B] lg:text-[0.9rem] text-xs">
                {d?.subtitle}
              </div>
            </div>
          </div>
        ))}
        </ScrollCarousel>: <>
          {LANDING_PAGE_HERO_CARDS.map((d, i) => (
          <div
            className="text-center  flex flex-col items-center bg-[#F8FCFD] lg:p-10 p-5 rounded-lg hover:bg-gradient-to-r from-cyan-100 to-purple-100 cursor-pointer"
            key={i}
          >
            <img
              alt={"hero-card" + d?.id}
              src={d?.img}
              className="lg:w-13 bg-white p-2 rounded-full"
              loading="lazy"
            />
            <div
              style={{
                fontFamily: "DM Sans",
                textAlign: "center",
                fontStyle: "normal",
                lineHeight: "normal",
              }}
            >
              <div className="text-[#130C40] lg:text-lg text-[0.8rem]">
                {d?.title}
              </div>
              <div className="text-[#3F3D4B] lg:text-[0.9rem] text-xs">
                {d?.subtitle}
              </div>
            </div>
          </div>
        ))}
        </>
      }
    </div>
  );
};

export default Herocards;
